import { render } from "./DecimalInput.vue?vue&type=template&id=523da2bd"
import script from "./DecimalInput.vue?vue&type=script&lang=js"
export * from "./DecimalInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__